import FeatureFlagModule from '@modules/FeatureFlagModule';

/**
 * Enhanced error context for Sentry logging.
 * Captures additional contextual information beyond just the error itself.
 */
export interface EnhancedErrorContext {
  /**
   * Current page URL
   */
  url: string;

  /**
   * Current route pathname
   */
  pathname: string;

  /**
   * Error timestamp
   */
  timestamp: string;

  /**
   * User agent string
   */
  userAgent: string;

  /**
   * Feature flags state
   */
  featureFlags: Record<string, boolean | undefined>;
}

/**
 * Captures enhanced error context including current page, feature flags, and environment info.
 * This provides Sentry with comprehensive context to debug issues.
 *
 * @returns Enhanced error context object
 */
export function captureEnhancedErrorContext(): EnhancedErrorContext {
  // Capture current page context
  const url = window.location.href;
  const pathname = window.location.pathname;

  // Capture timestamp
  const timestamp = new Date().toISOString();

  // Capture user agent
  const userAgent = navigator.userAgent;

  // Capture feature flags state
  // Note: We get all flags from FeatureFlagModule state
  const featureFlags = FeatureFlagModule.getAllFlags() || {};

  return {
    url,
    pathname,
    timestamp,
    userAgent,
    featureFlags,
  };
}
